export default class DeviceService {
	constructor(apiService) {
		this.apiService = apiService
	}

	createEntity(params) {
		return this.apiService.callPost('me/devices', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/devices/' + id, params)
	}

	deleteDevice(id, params) {
		return this.apiService.callDelete('me/devices/' + id, params)
	}

	deleteEntity(id, params) {
		return this.deleteDevice(id, params);
	}

	// SEARCH
	searchDeviceTypesForRecipients(params) {
		return this.apiService.callGet('me/device_types_search', params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/devices', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/devices/' + id, params)
	}

	getChannels(id) {
		return this.apiService.callGet('me/devices/' + id + '/channels')
	}

	getDeviceMetadata(id, params) {
		return this.apiService.callGet('devices/' + id + '/metadata', params)
	}

	restartDevices(ids, type, set = true) {
		return this.apiService.callPut('me/devices/restart', {
			id: ids,
			type: type,
			set: set,
		});
	}

	forceFullReloadDevices(ids, set = true) {
		return this.apiService.callPut('me/devices/forceFullReload', {
			id: ids,
			set: set,
		});
	}

	// MAC ADDRESS
	createMacAddress(idDevice, macAddress) {
		return this.apiService.callPost('me/devices/' + idDevice +'/macAddress/', macAddress);
	}

	deleteMacAddress(macAddress) {
		return this.apiService.callDelete('me/devices/macAddress/' + macAddress.id)
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceService.js